import {observable} from "mobx";
import UsuarioService from "../../../services/UsuarioService";
import DelegacaoTarefaService from "../../../services/DelegacaoTarefaService";
import {getByAtribute, stringToArray} from "../../../utils/formatar";
import moment from "moment/moment";
import _ from "lodash";

export default class PainelDelegacaoStore {
    @observable momentDataInicio;
    @observable momentDataTermino;
    @observable dataTerminoValidacao;
    @observable dataInicioValidacao;
    @observable loading;
    @observable usuarioFiltro;
    @observable usuarioDelegadoFiltro;
    @observable delegacoes;
    @observable delegacaoTela;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.loading = false;
        this.usuarioFiltro = null;
        this.usuarioDelegadoFiltro = null;
        this.resetDelegacaoTela();
        this.usuarioService = new UsuarioService();
        this.delegacaoService = new DelegacaoTarefaService();
        this.delegacoes = [];

        this.filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);

    }

    resetDelegacaoTela() {
        this.delegacaoTela = {
            idDelegacao: null,
            codigoRegra: null,
            ativa: null,
            usuarioResponsavel: null,
            usuarioDelegado: null,
            dataInicio: null,
            dataTermino: null
        };

        this.momentDataInicio = null;
        this.dataInicioValidacao = null;
        this.momentDataTermino = null;
        this.dataTerminoValidacao = null;
    }

    carregarLista(){
        this.loading = true;
        this.delegacaoService.listarDelegacoes(this.usuarioFiltro, this.usuarioDelegadoFiltro).then( resultado => {
            if(resultado.status == 200){
                this.delegacoes = [...resultado.data];
                this.loading = false;
            }
        }).catch(error => {
            this.loading = false;
            console.log("ERROR -------->" + JSON.stringify(error));
        });
    }

    setLista(value) {
        /*console.log("mudando ---------->" + JSON.stringify(value));*/
    }

    preencherModal(row){
        if(row) {
            this.delegacaoTela = Object.assign({}, row);
            if(row.dataInicio){
                this.setMomentDataInicio(moment(row.dataInicio));
            }
            if(row.dataTermino){
                this.setMomentDataTermino(moment(row.dataTermino));
            }
        } else {
            this.resetDelegacaoTela();
        }
    }

    remover() {
        return this.delegacaoService.deletarDelegacoes(this.delegacaoTela.idDelegacao).then(result => {
            if(result.status == 204){
                this.resetDelegacaoTela();
                this.modalStore.toggleModal();
                this.carregarLista();
            }
        }).catch(error => {
            this.modalStore.setSubmitMensagemErro(error.response.data.message)
        });
    }

    cadastrar() {
        return this.delegacaoService.cadastrarDelegacoes(this.delegacaoTela).then(response => {
            if(response.status == 200){
                this.resetDelegacaoTela();
                this.delegacoes.push(response.data)
            }
        });
    }

    editar() {
        return this.delegacaoService.editarDelegacao(this.delegacaoTela).then(response =>  {
            if(response.status == 200){
                this.resetDelegacaoTela();
                this.carregarLista();
            }
        });
    }

    setUsuarioFiltro(value) {
        if(value.length > 0){
            this.usuarioFiltro = value;
        }
        else{
            this.usuarioFiltro = null;
        }
    }

    setUsuarioDelegadoFiltro(value) {
        if(value.length > 0){
            this.usuarioDelegadoFiltro = value;
        }
        else{
            this.usuarioFiltro = null;
        }
    }

    setNovaDelegacaoUsuarioResponsavel(value) {
        this.delegacaoTela.usuarioResponsavel = value;
    }

    setNovaDelegacaoUsuarioDelegado(value) {
        this.delegacaoTela.usuarioDelegado = value;
    }

    setMomentDataInicio(value) {
        if(value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            let endDate = this.momentDataTermino;
            if (endDate && startDate && startDate.isAfter(endDate)) {
                const temp = startDate;
                startDate = endDate;
                endDate = temp
            }
            this.momentDataInicio = startDate;
            if (startDate) {
                this.delegacaoTela.dataInicio = startDate.toJSON();
            }
            else {
                this.delegacaoTela.dataInicio = null;
            }
            this.momentDataTermino = endDate;
            if (endDate) {
                this.delegacaoTela.dataTermino = endDate.toJSON();
            }
            else {
                this.delegacaoTela.dataTermino = null;
            }
            this.dataInicioValidacao =  moment(value).format('DD/MM/YYYY');
        }
        else {
            this.momentDataInicio = null;
            this.delegacaoTela.dataInicio = null;
            this.dataInicioValidacao = null;
        }

    }

    setMomentDataTermino(value) {
        if(value) {
            let startDate = this.momentDataInicio;
            let endDate = value;
            endDate = moment(endDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            if (endDate && startDate && startDate.isAfter(endDate)) {
                const temp = startDate;
                startDate = endDate;
                endDate = temp;
            }
            this.momentDataInicio = startDate;
            if (startDate) {
                this.delegacaoTela.dataInicio = startDate.toJSON();
            }
            else {
                this.delegacaoTela.dataInicio = null;
            }
            this.momentDataTermino = endDate;
            if (endDate) {
                this.delegacaoTela.dataTermino = endDate.toJSON();
            }
            else {
                this.delegacaoTela.dataTermino = null;
            }
            this.dataTerminoValidacao =  moment(value).format('DD/MM/YYYY');
        } else {
            this.momentDataTermino = null;
            this.delegacaoTela.dataTermino = null;
            this.dataTerminoValidacao = null;
        }

    }

    setDataTerminoCheck(value){
        this.dataTerminoValidacao = value;
        if(!value) {
            this.momentDataTermino = null;
        }
    }

    setDataInicioCheck(value){
        this.dataInicioValidacao = value;
        if(!value) {
            this.momentDataInicio = null;
        }
    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data) {
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

}